import React, { useState, useMemo, createContext } from 'react';
import PropTypes from 'prop-types';

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isSideMenuOpen, setisSideMenuOpen] = useState(false);
  const [isPagesMenuOpen, setisPagesMenuOpen] = useState(false);
  const [isNotificationsMenuOpen, setIsNotificationsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  function togglePagesMenu() {
    setisPagesMenuOpen(!isPagesMenuOpen);
  }

  function toggleSideMenu() {
    setisSideMenuOpen(!isSideMenuOpen);
  }

  function toggleNotificationsMenu() {
    setIsNotificationsMenuOpen(!isNotificationsMenuOpen);
  }

  function toggleProfileMenu() {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  }

	function closeProfileMenu() {
		setIsProfileMenuOpen(false);
	}

  function checkLogin() {
    const isLoggedIn = localStorage.getItem('is_login') ?? false;
    return isLoggedIn;
  }

  const value = useMemo(
    () => ({
      isSideMenuOpen,
      isPagesMenuOpen,
      isNotificationsMenuOpen,
      isProfileMenuOpen,
      togglePagesMenu,
      toggleSideMenu,
      toggleNotificationsMenu,
      toggleProfileMenu,
			closeProfileMenu,
      checkLogin
    }),
    [
      isSideMenuOpen,
      isPagesMenuOpen,
      isNotificationsMenuOpen,
      isProfileMenuOpen
    ]
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.element
};
